/**
 * Strip characters that are illegal in filenames on common OSes
 * (Windows reserved set + slashes). Used to build download filenames
 * from user-supplied strings like story titles or voice names.
 */
export function sanitizeFilenameSegment(value: string): string {
  return value.replace(/[\\/:*?"<>|]+/g, '_').trim();
}

/**
 * Today's date as YYYY-MM-DD, for filename stamping. UTC slice keeps it
 * stable regardless of client timezone.
 */
export function todayStamp(): string {
  return new Date().toISOString().slice(0, 10);
}
